import type { LucideIcon, LucideProps } from 'lucide-react';
import { cn } from '../../lib/cn';

export type { LucideIcon };

export interface IconProps extends Omit<LucideProps, 'ref'> {
  icon: LucideIcon;
  /** 16 in Text und Buttons, 17 in der Navigation, 22–30 in SettingRow und EmptyState. */
  size?: number;
  /** Nur setzen, wenn das Icon allein Bedeutung trägt. */
  label?: string;
}

/** Ein Lucide-Icon in currentColor; Strich 1,75, ab 26 px 1,5. */
export function Icon({ icon: Glyph, size = 16, strokeWidth, label, className, ...rest }: IconProps) {
  return (
    <Glyph
      size={size}
      strokeWidth={strokeWidth ?? (size >= 26 ? 1.5 : 1.75)}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      className={cn('shrink-0', className)}
      {...rest}
    />
  );
}
